<template>
<div>
    <WaitMessage :ob="claimob" />

    <div v-if="!claimob.wait && !claimob.message">

        <template v-if="isBefore(claimob.status)">
            <h2><b>{{claimob.status.name}}</b></h2>
            <div>
                <div v-if="claimob.reward.is">Начислено вознаграждение - <b>{{claimob.reward.sum}}р</b></div>
            </div>
            <div v-if="claimob.status.detail" v-html="claimob.status.detail"></div>
        </template>

        <template v-else-if="isShould(claimob.status)">
            <template v-if="claimob.access.allow">
                <FinishClaim  :claim="claimob.claim" :status="claimob.status" :reward="claimob.reward" />
            </template>
            <template v-else>
                <h2 v-text="claimob.access.whynot"></h2>
            </template>
        </template>

        <template v-else-if="isReady(claimob.status)">
            <template v-if="claimob.access.allow">
                <StartWdr :claim_num="claimob.claim.num" />
            </template>
            <template v-else>
                <h2 v-text="claimob.access.whynot"></h2>
            </template>
        </template>

        <template v-else-if="isActive(claimob.status)">
            <RewardShow :claim="claimob.claim" :status="claimob.status" :actreward="claimob.actreward" />
        </template>

    </div>
</div>
</template>

<script setup>
import {ref, unref, computed, onMounted, reactive} from 'vue'
import {getWithdrawalSummary} from '@/actions.js'
import { useRouter } from 'vue-router/composables'
import StartWdr from '@/payout/StartWdr.vue'
import {isBefore, isShould, isReady, isActive} from '@/payout/util.js'

import WaitMessage from '@/comp/Payout/WaitMessage.vue'
import FinishClaim from '@/payout/FinishClaim.vue'
import RewardShow from '@/payout/RewardShow.vue'

const router = useRouter();

const props = defineProps({
  claim_num: String, 
})

const claimob = reactive({
  claim : null,
  status: null,
  reward: null,
  actreward: null,
  access: null,
  wait: true,
  message: '',
})



const load = () => {
    claimob.claim = null
    claimob.wait = true
    claimob.message = ''
    const {claim_num} = props

    getWithdrawalSummary({claim_num, actreward:true}).then( (
        {claim, status, reward, actreward, access,}
    ) => {
      claimob.wait = false
      Object.assign( claimob, { claim, status, reward, actreward, access } )
    }, message => {
      claimob.wait = false
      claimob.message = `Не удалось получить информацию по заявке ${claim_num}: ${message}`
    } )
}


onMounted(load)


</script>